/**
 * SeverityChip — plain bordered span (MT Chip fights the pill).
 *
 * Mono uppercase, 4px radius, severity color per the SEV map.
 */

export type Severity = 'critical' | 'high' | 'medium' | 'low' | 'clean';

interface SeverityChipProps {
  /** Severity level */
  sev: Severity;
  /** Override the displayed label (defaults to the severity name) */
  label?: string;
  /** Additional CSS classes */
  className?: string;
}

const SEV: Record<Severity, string> = {
  critical: 'text-phish-critical border-phish-critical bg-phish-critical/15',
  high: 'text-phish-high border-phish-high',
  medium: 'text-phish-medium border-phish-medium',
  low: 'text-phish-low border-phish-border-strong',
  clean: 'text-phish-clean border-phish-clean',
};

/**
 * Severity indicator chip — terminal-green/amber/red bordered span.
 */
export function SeverityChip({ sev, label, className = '' }: SeverityChipProps) {
  return (
    <span
      className={`inline-flex items-center h-6 px-2 font-mono text-xs uppercase border rounded-phish whitespace-nowrap ${SEV[sev]} ${className}`}
    >
      {label ?? sev}
    </span>
  );
}

export default SeverityChip;
